<template lang="pug">
app-page(v-app-scroll="handleScroll" title="Управление составом категорий" :loading="loading" @search="text => (search = text.toLowerCase())")
  app-toolbar(:title="'Группа категорий - ' + groupCategory.name" back)
    app-toolbar-item.ml-2(label="Показать" :items="filterItems" key-name="title" min-width="120" @select="filterBy") {{ currentFilter }}
    app-toolbar-item.ml-2(label="Сортировать" :items="sorterItems" key-name="title" min-width="120" @select="sortBy") {{ currentSort }}

  .text-right
    v-chip.ma-2(v-if="search" color="#757575" text-color="white" small label close @click:close="search = null") Поиск:&nbsp;<b>{{ search }}</b>

  app-group-animation
    app-group-item(v-for="c in list" :key="c.id" @click.native="toggleGroup(c)" cols="12")
      card-toggle(:title="uidCat(c)" :selected="isGroupCategory(c)" data-aos="fade-top")
        app-card-title(v-html="titleCat(c)")
        app-card-caption(v-if="c.startDate" style="color: red;") Начало дествия: {{ c.startDate ? $_shortFormatRu(c.startDate) : '' }}
        app-card-caption(v-if="c.endDate" style="color: red;") Срок дествия до: {{ c.endDate ? $_shortFormatRu(c.endDate) : '' }}
        app-card-caption(v-if="c.outdated" style="color: red;") Устаревшая

  button-back-page(@click.native="backComposition()") Готово
</template>

<script>
import { caseService } from "@/_services";
import { mapGetters,  mapMutations, mapState } from 'vuex'

import CardToggle from '../components/CardToggle'
import ButtonBackPage from '../components/ButtonBackPage'

import { $_app_moment } from "@/common/AppMoment.js"

import moment from 'moment'
moment.locale('ru')

export default {
  mixins: [ $_app_moment ],

  props: {
    groupId: null
  },

  components: {
    CardToggle,
    ButtonBackPage
  },

  data () {
    return {
      groupCategory: '',
      search: null,
      limit: 10,
    }
  },

  mounted () {
    if (this.groupId) this.loadGroupCategory()

    this.$store.commit('setInCategory', true)
    this.$store.dispatch('category/INIT')
  },

  computed: {
    ...mapGetters('category', ['isCategoriesLoaded']),
    ...mapState('category', ['selectedSort', 'selectedFilter', 'categories']),


    sorterItems () {
      return ['по названию', 'по индексу'].map(el => ({ title: el }))
    },

    filterItems () {
      return ['все', 'активные', 'архивные', 'истек срок действия'].map(el => ({ title: el }))
    },

    currentSort () {
      return this.sorterItems[this.selectedSort].title
    },

    currentFilter () {
      return this.filterItems[this.selectedFilter].title
    },

    loading () {
      return !this.isCategoriesLoaded
    },

    list () {
      return this.limit ? this.listCategories.slice(0, this.limit) : this.listCategories
    },

listCategories () {
      let list = this.categories.list

      switch (this.selectedFilter) {
        case 1: {
          list = list.filter(item => item.outdated == null)
          list = list.filter(item =>  !item.endDate || ( item.endDate && moment(item.endDate).isAfter(moment()) ) )
          break
        }
        case 2: list = list.filter(item => item.outdated != null); break;
        case 3: list = list.filter(item =>  item.endDate && moment(item.endDate).isBefore(moment()) ); break;
      }

      if (this.search) {
        list = list.filter(item => item.gasCategoryUid.toString().toLowerCase().includes(this.search) || item.title.toLowerCase().includes(this.search))
      }

      switch (this.selectedSort) {
        case 1: list.sort((a, b) => a.gasCategoryUid - b.gasCategoryUid || b.id - a.id); break;
        default: list.sort((a, b) => a.title.localeCompare(b.title) || b.id - a.id)
      }
      
      return list
    },
  },

  methods: {
    ...mapMutations('category', ['selectSort', 'selectFilter', 'setCategoriesStatus']),

    sortBy(item, index) {
      this.selectSort(index)
    },

    filterBy(item, index) {
      this.selectFilter(index)
    },

    titleCat (cat) {
      if (!this.search || this.search.length == 0 )  return cat.title

      return cat.title.replace(new RegExp(this.search, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },

    uidCat (cat) {
      if (!this.search || this.search.length == 0 ) return cat.gasCategoryUid

      return cat.gasCategoryUid.toString().replace(new RegExp(this.search, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },
    
    loadGroupCategory () {
      caseService.showGroupCategory(this.groupId)
      .then(data => this.groupCategory = data)
    },

    isGroupCategory (c) {
      if (this.groupCategory.caseCategory)
        return this.groupCategory.caseCategory.find(item => item.id === c.id)
    },

    toggleGroup (c) {
      if (this.isGroupCategory (c)) this.groupCategory.caseCategory = this.groupCategory.caseCategory.filter(cat => c.id !== cat.id )
      else this.groupCategory.caseCategory.push(c)
    },

    backComposition () {
      caseService.addGroupCategory(this.groupCategory).then(() => this.$router.push({ path: `/admin/group` }))
    },

    handleScroll: function (evt, el) {
      let bottomOffset = el.scrollHeight - window.scrollY
      if (bottomOffset < 2 * window.innerHeight) {
        this.limit += 6
      }
      return false
    },

    resetList () {
      this.limit = 10
    }
  },

  watch: {
    cases () {
      this.resetList()
    }
  },

  beforeDestroy() {
    this.$store.commit('setInCategory', false)
  }
}
</script>


